import {
  reduce,
  assoc,
  keys,
  curry,
  converge,
  concat,
  toUpper,
  head,
  tail,
  compose,
  type,
} from 'ramda';
export const renameKeys = curry((keysMap: any, obj: any) => {
  return reduce(
    (acc: any, key: string | number | symbol) =>
      assoc(keysMap[key] || key, obj[key], acc),
    {},
    keys(obj)
  );
});

export const firstUpper = converge(concat, [compose(toUpper, head), tail]);

/*
  Like ramdas intersperce but intersperses an array of seperators instead of one seperator
  Example: intersperseAll(['n', '!], ['ba', 'a', 'a']); //=> ['ba', 'n', '!', 'a', 'n', '!', 'a']
*/
export const intersperseAll = <E>(separators: E[], list: E[]): E[] => {
  let out = [];
  let idx = 0;
  let length = list.length;
  while (idx < length) {
    if (idx === length - 1) {
      out.push(list[idx]);
    } else {
      out.push(list[idx], ...separators);
    }
    idx += 1;
  }
  return out;
};

export const isFunction = (val: any): val is Function => {
  return type(val) === 'Function';
};

export const isObject = <T>(val: T) => {
  return type(val) === 'Object';
};

export const isPromise = (value: any): value is Promise<any> =>
  isObject(value) && isFunction(value.then);

export const isArray = (val: any): boolean => {
  return type(val) === 'Array';
};
